import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, QueryList, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { NxExpansionPanelHeaderComponent } from '@aposin/ng-aquila/accordion';
import { Agent } from '@shared/models/agent';
import { MaInsuranceLife } from '@shared/models/ma-insurance';
import { MaInsuranceCoverage } from '@shared/models/ma-insurance-coverage';
import { MaInsuranceCoverageInsurancePerson } from '@shared/models/ma-insurance-coverage-insurance-person-';

@Component({
    selector: 'app-ma-insurance-life',
    templateUrl: './ma-insurance-life.component.html',
    styleUrls: ['./ma-insurance-life.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class MaInsuranceLifeComponent {
    @Input() maInsurance: MaInsuranceLife;
    @Input() agent: Agent | null;

    @ViewChildren('#header') panelHeaders: QueryList<NxExpansionPanelHeaderComponent>;

    constructor(private changeDetectorRef: ChangeDetectorRef) {
        
    }

    hasManyInsuredPersons(insuredPersons: Array<MaInsuranceCoverageInsurancePerson>): boolean {
        return insuredPersons.length > 1;
    }


}
